import type { HelpFile } from '../../types/help'
import { FunctionGroupDetailTestIds } from '../../../testids/FunctionGroupDetailTestIds'

export const functionGroupDetailHelp: HelpFile = {
  docPage: '/docs/access/role-assignments',
  texts: {
    [FunctionGroupDetailTestIds.functionGroupDetailPage]:
      'Detail view of a function group — its access profiles, attributes, and the identities that inherit from it.',
    [FunctionGroupDetailTestIds.fgAccessProfilesCard]:
      'Access profiles directly associated with this function group. Identities assigned to this function group (and its descendants) inherit these access profiles.',
    [FunctionGroupDetailTestIds.apEmptyState]:
      'No access profiles are linked to this function group. Add one to grant access to assigned identities.',
    [FunctionGroupDetailTestIds.apWarning100]:
      'This function group is associated with more than 100 access profiles. Consider splitting it for clearer governance.',
    [FunctionGroupDetailTestIds.btnRetryAp]:
      'Retry loading the access profiles after a transient error.',
    [FunctionGroupDetailTestIds.cardFunctionGroupDetails]:
      'Core attributes of the function group — name, code, description, and lifecycle status.',
    [FunctionGroupDetailTestIds.cardTitleAttributes]:
      'Custom attributes captured for this function group, defined by your tenant\u2019s schema.',
    [FunctionGroupDetailTestIds.colCode]:
      'Stable machine-readable code of the access profile.',
    [FunctionGroupDetailTestIds.colEnvironment]:
      'Target environment (production, test, development) on which the access profile applies.',
    [FunctionGroupDetailTestIds.colName]: null,
    [FunctionGroupDetailTestIds.colResource]:
      'Resource on the target system to which the access profile gives access.',
    [FunctionGroupDetailTestIds.colRiskLevel]:
      'Risk classification of the access profile (low, medium, high, critical).',
    [FunctionGroupDetailTestIds.colStatus]:
      'Lifecycle status of the access profile — active, deprecated, or retired.',
  },
}
